const minArrayLength = (length) => ({
    name: "min-array-length",
    validate: (v) => v != null && v.length >= length,
    length,
});
exports.minArrayLength = minArrayLength;
